import { render } from "./Manufacturing.vue?vue&type=template&id=dd9a10d6&scoped=true"
import script from "./Manufacturing.vue?vue&type=script&lang=js"
export * from "./Manufacturing.vue?vue&type=script&lang=js"

import "./Manufacturing.vue?vue&type=style&index=0&id=dd9a10d6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd9a10d6"]])

export default __exports__